import { WrapperSize, JackpotTier, WrapperJackpotTiers } from '../../types';

export const checkForWonJackpot = (
  tiers: WrapperJackpotTiers
): JackpotTier | undefined => {
  for (const tier of tiers) {
    if (tier.state === 'won' && tier.winValue && tier.nextJackpotName) {
      return tier;
    }
  }
  return;
};

export const checkForActiveJackpot = (
  tiers: WrapperJackpotTiers
): JackpotTier | undefined => {
  // Do not consider first jackpot
  for (let i = 1; i < tiers.length; i++) {
    const tier = tiers[i];
    if (tier.state === 'active') {
      return tier;
    }
  }
  return;
};

export const selectJackpots = (
  tiers: WrapperJackpotTiers,
  wrapperSize: WrapperSize
): JackpotTier[] => {
  const wonJackpot = checkForWonJackpot(tiers);
  if (wonJackpot) {
    return [wonJackpot];
  }

  const selectedJackpots = [tiers[0]];
  if (wrapperSize === 'slim') {
    const activeJackpot = checkForActiveJackpot(tiers);
    selectedJackpots.push(activeJackpot ? activeJackpot : tiers[1]);
  } else if (wrapperSize === 'wide') {
    selectedJackpots.push(tiers[1], tiers[2]);
  }

  return selectedJackpots;
};

export const decideJackpotBoxScale = (
  index: number,
  wrapperSize: WrapperSize
) => {
  if (index === 0) {
    return 'medium';
  }
  return wrapperSize === 'wide' ? 'tiny' : 'small';
};
